export default "__VITE_ASSET__DjT0R4dv__"